import { baseApi } from "./baseApi"
import { CarEngineModel } from "@/types/api"

export const carEnginesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCarEngines: builder.query<CarEngineModel[], number>({
      query: (modelId) =>  `CarEngines/${modelId}`,
      keepUnusedDataFor: 60 * 60 * 1000, // 1 hour
    }),
  }),
})

export const { useLazyGetCarEnginesQuery } = carEnginesApi